import React from "react";
import MasterDataPage from "../MasterData/MasterDataPage";
import { createDesignation, deleteDesignation, getDesignations, updateDesignation } from "./designationApi";
import "./designation.css";

const config = {
  title: "Designation",
  subtitle: "Manage company job structures, rankings, and structural designations.",
  singular: "Designation",
  icon: "ri-id-card-line",
  iconClass: "is-green",
  api: { fetch: getDesignations, create: createDesignation, update: updateDesignation, remove: deleteDesignation },
  exportName: "besarawak-designations.csv",
  searchPlaceholder: "Search designation...",
  pageSize: 25,
  empty: { name: "", description: "", status: "Active" },
  required: ["name", "description"],
  duplicate: (items, value, id) => items.some((item) => item.id !== id && item.name.toLowerCase() === value.name.trim().toLowerCase()),
  duplicateMessage: "This designation already exists.",
  normalize: (value) => { value.name = value.name.trim(); value.description = value.description.trim(); },
  search: (item) => `${item.name} ${item.description}`,
  display: (item) => item.name,
  columns: [
    { label: "Designation Name", value: (item) => item.name },
    { label: "Description", value: (item) => item.description, muted: true },
  ],
  fields: [
    { key: "name", label: "Designation Name", required: true, placeholder: "e.g. Executive" },
    { key: "description", label: "Description", required: true, type: "textarea", full: true },
    { key: "status", label: "Status", type: "select" },
  ],
};

const DesignationPage = () => <MasterDataPage config={config} />;
export default DesignationPage;
